module.exports = __webpack_public_path__ + "static/media/sygnet.c8d5c2d9.svg";